import { CallbackErrorAxios, CallbackWarningAxios, HeaderNavigateBar, UUID } from '@umanforge/common';
import EventManagerModal from 'components/modals/eventManagers/eventManagerModal.component';
import { KEY } from 'constants/local_storage_key.constant';
import { TableCreation } from 'interfaces/types.interface';
import React from 'react';


interface EventManagerNavigationBarSkeletonProps {
  children?: React.ReactNode;
  selectedClientIdKey: string;
  selectedSiteIdKey: string;
  selectedSectorIdKey: string;
  onSectorChanged?: ( sectorId: UUID | undefined ) => void;
  onAxiosWarning?: CallbackWarningAxios;
  onAxiosError?: CallbackErrorAxios;
  eventManagerId: UUID | undefined;
  isViewMode: boolean;
  isPopupVisible: boolean;
  setIsPopupVisible: ( value: boolean ) => void;
  updateTable: ( table: TableCreation ) => Promise<UUID | null>;
  deleteTable: ( ( tableId: string ) => Promise<boolean> ) | undefined;
}

export const EventManagerNavigationBarSkeleton: React.FC<EventManagerNavigationBarSkeletonProps> = ( {
  children,
  eventManagerId,
  isPopupVisible,
  isViewMode,
  setIsPopupVisible,
  updateTable,
  deleteTable,
  onSectorChanged,
  onAxiosWarning,
  onAxiosError
} ) => {

  //---------------- Front ----------------\\
  return (
    <>
      {
        isViewMode ?
          <div className='flex max-2xl:flex-col w-full py-2 px-4 max-2xl:gap-3 2xl:gap-5 justify-between rounded-md bg-white dark:bg-dark-bg-light text-gray-600 dark:text-gray-400'>
            { children }
          </div>
          :
          <HeaderNavigateBar
            selectedClientIdKey={ KEY.SELECTED_CLIENT_ID }
            selectedSiteIdKey={ KEY.SELECTED_SITE_ID }
            selectedSectorIdKey={ KEY.SELECTED_SECTOR_ID }
            onSectorChanged={ onSectorChanged }
            onWarning={ onAxiosWarning }
            onError={ onAxiosError }
          >
            { children }
          </HeaderNavigateBar>
      }

      {
        isPopupVisible && (
          <EventManagerModal
            tableId={ eventManagerId }
            onClose={ () => { setIsPopupVisible( false ); } }
            onSubmit={ updateTable }
            onDeleteEventManager={ deleteTable }
          />
        )
      }
    </>
  );
};